import {AfterViewInit, Component, Input, OnInit, Optional, TemplateRef, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {User} from '@modules/administration/users/interfaces/user.model';
import {RoleType, RoleTypes} from '@modules/administration/administration.const';
import {UserConstant, UserStatus} from '@modules/administration/users/user.constant';
import {UsersService} from '@modules/administration/users/services/users.service';
import {LocalStorage} from '@core/storage/storage';
import {LOCAL_STORAGE} from '@core/constant/storage.constant';
import {BaseResponse} from '@core/models/base-response.model';
import {MESSAGE_CODE} from '@shared/constants/message-code.constant';
import {Mode} from '@shared/enums/mode.enum';
import {VALIDATORS} from '@modules/administration/users/components/edit-user/edit-user.validator';
import {NzModalRef} from 'ng-zorro-antd/modal';
import {NotificationService} from '@shared/services/notification.service';
import {EditUserRequest} from '@modules/administration/users/interfaces/user.request';

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.css']
})
export class EditUserComponent implements OnInit, AfterViewInit {
  @Input() data: User;
  @Input() mode: Mode = Mode.ADD;
  readonly userRoleTypes = RoleTypes;
  readonly userStatus = UserConstant.USER_STATUS;
  readonly VALIDATORS = VALIDATORS;
  readonly MODE = Mode;
  roleCanSee: any[] = [];

  form: FormGroup;
  isSubmitted: boolean = false;
  showPassword: boolean = false;
  showRepeatPassword: boolean = false;

  @ViewChild("editFooter") editFooter: TemplateRef<any>;

  constructor(
    @Optional() private modalRef: NzModalRef,
    private fb: FormBuilder,
    private notiService: NotificationService,
    private userService: UsersService) {
    this.form = this.fb.group({
      id: null,
      userName: [null, [Validators.required, Validators.pattern('^[a-zA-Z][a-zA-Z0-9_.]*'), Validators.minLength(6)]],
      userRole: [RoleType.ADMIN, [Validators.required]],
      status: [UserStatus.INACTIVE, [Validators.required]],
      name: [null, [Validators.required]],
      email: [null, [Validators.email]],
      phoneNumber: [null, [Validators.pattern('^0[0-9]{9,10}$')]],
      password: [null, [Validators.minLength(6), Validators.pattern('^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+\\-=\\[\\]{};\':"\\\\|,.<>\\/?]).{8,}$')]],
      repeatPassword: [null, [Validators.minLength(6)]]
    });
    let currentUser = LocalStorage.getItem(LOCAL_STORAGE.KEY.USER);
    if (currentUser) {
      this.userService.getRoleCanSee(currentUser.id).subscribe((res:BaseResponse<any, any>) => {
        if (res?.messageCode === MESSAGE_CODE.SUCCESS) {
          if (res.data != null)
            this.roleCanSee = RoleTypes.filter(r => res.data.includes(r.value));
        }
      })
    }
  }

  get f() { return this.form.controls; }

  ngOnInit(): void {
    if (this.mode === Mode.ADD) {
      this.f.password.setValidators(Validators.required);
      this.f.repeatPassword.setValidators(Validators.required);
      this.f.status.disable();
    }
    this.patchData();
  }

  submitForm() {
    this.isSubmitted = true;
    for (const i in this.form.controls) {
      this.form.controls[ i ].markAsDirty();
      this.form.controls[ i ].updateValueAndValidity();
    }
    if(this.f.password.value !== this.f.repeatPassword.value) this.f.repeatPassword.setErrors({notMatch: true})
    if (this.form.valid) {
      let request: EditUserRequest = this.form.value;
      switch (this.mode) {
        case Mode.ADD:
          this.addUser(request);
          break;
        case  Mode.EDIT:
          this.editUser(request);
          break;
      }
    }
  }

  addUser(request: EditUserRequest) {
    this.userService.add(request).subscribe((res: BaseResponse<any, any>) => {
      if (res?.messageCode === MESSAGE_CODE.SUCCESS) {
        this.notiService.success("Thêm mới thành công")
        this.modalRef.destroy({refresh: true});
        this.isSubmitted = false
      }
    })
  }

  editUser(request: EditUserRequest) {
    this.userService.edit(request).subscribe((res: BaseResponse<any, any>) => {
      if (res?.messageCode === MESSAGE_CODE.SUCCESS) {
        this.notiService.success("Cập nhật thành công")
        this.modalRef.destroy({refresh: false});
        this.isSubmitted = false
      }
    })
  }


  private patchData() {
    if(this.data) {
        this.form.patchValue(this.data)
        this.f.userName.disable();
    }
  }

  cancel() {
    this.modalRef?.destroy();
  }

  ngAfterViewInit(): void {
    Promise.resolve().then(() => {
      this.modalRef?.updateConfig({
        nzFooter: this.editFooter
      });
    });
  }
}
